import { Grid } from '@mui/material';
import BlockComponentButton from '../../../../../models/BlockComponentValues/BlockComponentButton';
import BlockData from '../../../../../models/BlockData';
import Utils from '../../../../../utils/Utils';
import CloseButton from '../../../../Buttons/Close';
import LinkButton from '../../../../Buttons/LinkButton';

interface LogoHeaderButtonsProps {
  leftButton: BlockComponentButton;
  rightButton: BlockComponentButton;
  isEditing: boolean;
  isTemplate: boolean;
  blockData: BlockData[];
  onSaveLeftButton: (item: BlockComponentButton) => void;
  onSaveRightButton: (item: BlockComponentButton) => void;
  onRemoveLeftButton: () => void;
  onRemoveRightButton: () => void;
  mainColor: string;
  fontFamily?: string;
}

const LogoHeaderButtons = ({
  leftButton, rightButton, isEditing, isTemplate, blockData, onSaveLeftButton, onSaveRightButton, onRemoveLeftButton, onRemoveRightButton, mainColor, fontFamily,
}: LogoHeaderButtonsProps) => (
  <Grid container justifyContent="center" alignItems="center">
    {leftButton && (
      <Grid item sx={Utils.hoverBorder(isEditing)}>
        <CloseButton
          show={isEditing}
          updateHandler={onRemoveLeftButton}
        />
        <LinkButton
          mainColor={mainColor}
          fontFamily={fontFamily}
          button={leftButton}
          blockData={blockData}
          isEditable={isEditing && !isTemplate}
          isTemplate={isTemplate}
          updateHandler={(item) => onSaveLeftButton(item)}
        />
      </Grid>
    )}

    {rightButton && (
      <Grid item sx={Utils.hoverBorder(isEditing)}>
        <CloseButton
          show={isEditing}
          updateHandler={onRemoveRightButton}
        />
        <LinkButton
          mainColor={mainColor}
          fontFamily={fontFamily}
          button={rightButton}
          blockData={blockData}
          isEditable={isEditing && !isTemplate}
          isTemplate={isTemplate}
          updateHandler={(item) => onSaveRightButton(item)}
        />
      </Grid>
    )}

  </Grid>
);

export default LogoHeaderButtons;
